import React from 'react';
import PropTypes from 'prop-types';
import { Radio, Form } from 'antd';

const TriggerPointForm = ({
  t,
  onChange,
  modalType,
  triggerPoint,
  form: { getFieldDecorator },
}) => {
  return (
    <div className="trigger-point-form">
      <h3 className="trigger-point-form__title">
        {t('cms.commission.trigger_point.title', 'Trigger Point')}
      </h3>

      <div className="trigger-point-form__description">
        {t('cms.commission.trigger_point.description', 'Choose Commission Plan Trigger Point:')}
      </div>

      {getFieldDecorator('triggerPoint', {
        initialValue: triggerPoint,
        rules: [
          {
            required: true,
            message: t(
              'cms.commission.trigger_point.error.required',
              'Please select a trigger point',
            ),
          },
        ],
      })(
        <Radio.Group
          disabled={modalType === 'edit'}
          onChange={e => {
            onChange(e.target.value);
          }}
        >
          <Radio value="CREATED" className="trigger-point-form__radio">
            {t('cms.commission.trigger_point.create_order', 'Create Order/Opp')}
          </Radio>
          <Radio value="COMPLETED" className="trigger-point-form__radio">
            {t('cms.commission.trigger_point.complete_order', 'Complete Order/Opp')}
          </Radio>
        </Radio.Group>,
      )}
    </div>
  );
};

TriggerPointForm.propTypes = {
  t: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
};

export default Form.create()(TriggerPointForm);
